export const getIovationBlackbox = () => {

  if (!window.iovation?.getBlackbox) {
    throw new Error(`Iovation not available. Validate that you are properly loading Iovation's js scripts (config.js and loader.js)`);
  }

  const { blackbox, finished } = window.iovation.getBlackbox();
  if (!finished) {
    throw new Error('Iovation blackbox was not ready.');
  }

  return blackbox;
};
